import React from 'react';

const Footer = () => {
  const footerStyle = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '8px',
    textAlign: 'center',
    fontSize: '0.8rem',
    color: '#666',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderTop: '1px solid #eee'
  };

  return (
    <footer style={footerStyle}>
      Powered by feedfilter sauce
    </footer>
  );
};

export default Footer; 